import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import AssetList from "../AssetsList/AssetsList.component";
import useStyles from "../AssetsOverview/AssetsOverview.styles";

const AssetDefaultTable = ({
  assetList,
  assetType,
  projectId,
  statusList,
  isToggleView,
  updateRefreshCounter,
  setIsViewModalOpen,
  fetchFile,
  handleTableScroll,
  tableRef,
  scrollValue,
  isAssetTogglerOn,
  handleEditAssetModalState,
}) => {
  const classes = useStyles();

  return (
    <TableContainer
      className={classes.assetsTableContainer}
      onScroll={handleTableScroll}
      ref={tableRef}
    >
      <Table aria-label="simple table" className={classes.table}>
        <TableHead className={classes.tableHeader}>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.headTableTwo} align="left">
              Asset Name
            </TableCell>
            <TableCell className={classes.headTableTwo} align="center">
              Description
            </TableCell>
            <TableCell className={classes.headTable} align="center">
              Type
            </TableCell>
            <TableCell className={classes.headTable} align="center">
              Status
            </TableCell>
            <TableCell className={classes.headTable} align="center">
              Last Modified
            </TableCell>
            <TableCell className={classes.headTable} align="center">
              Departments
            </TableCell>
            <TableCell className={classes.headTableTwo} align="right">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          className={classes.tableBody}
          onScroll={handleTableScroll}
          ref={tableRef}
          onLoad={() => {
            if (tableRef && tableRef.current && tableRef.current.scrollTop) {
              tableRef.current.scrollTop = scrollValue;
            }
          }}
          style={{
            height:
              assetList.count > 50
                ? `calc(100vh - 290px)`
                : `calc(100vh - 250px)`,
          }}
        >
          {assetList.results?.map((res) => {
            return (
              <AssetList
                key={res.id}
                assetType={assetType}
                data={res}
                projectId={projectId}
                statusList={statusList}
                isToggleView={false}
                updateRefreshCounter={updateRefreshCounter}
                setIsViewModalOpen={setIsViewModalOpen}
                fetchFile={fetchFile}
                isAssetTogglerOn={isAssetTogglerOn}
                handleEditAssetModalState={handleEditAssetModalState}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AssetDefaultTable;
